/**
 * Job entity — mirrors `leviathan_master.jobs`.
 *
 * Schedule is stored as a standard 5-field cron or AWS EventBridge 6-field
 * expression. Transformation is driven by `transformConfig` (JSON).
 */
import { z } from 'zod';
import { ConnectorId, ISO8601Date, JobId, TenantId, UserId, } from '../primitives/index.js';
import { JobStatus } from '../enums/index.js';
export const JobTransformConfigSchema = z.record(z.string(), z.unknown());
export const JobSchema = z.object({
    id: JobId,
    connectorId: ConnectorId,
    tenantId: TenantId,
    name: z.string().min(1).max(100),
    description: z.string().nullable(),
    /** Cron expression (5-field) or `cron(...)` AWS format. Validated server-side. */
    schedule: z.string().min(1).max(50),
    transformConfig: JobTransformConfigSchema.nullable(),
    status: JobStatus,
    priority: z.coerce.number().int().min(0).max(10),
    createdBy: UserId.nullable(),
    createdAt: ISO8601Date,
    updatedAt: ISO8601Date,
});
export const JobCreateSchema = z.object({
    connectorId: ConnectorId,
    name: z.string().min(1).max(100),
    description: z.string().optional(),
    schedule: z.string().min(1).max(50),
    transformConfig: JobTransformConfigSchema.optional(),
    priority: z.coerce.number().int().min(0).max(10).default(5),
});
export const JobUpdateSchema = z
    .object({
    name: z.string().min(1).max(100),
    description: z.string().nullable(),
    schedule: z.string().min(1).max(50),
    transformConfig: JobTransformConfigSchema.nullable(),
    status: JobStatus,
    priority: z.coerce.number().int().min(0).max(10),
})
    .partial();
//# sourceMappingURL=job.js.map